import { observer } from "mobx-react-lite"

import { Search } from "@/components/search"
import { Switch } from "@/components/switch"
import { useScaleApplication } from "@/domains/application/use-scale-application"
import { SwitchDetailedMode } from "@/domains/common/components/switches/switch-detailed-mode"
import { SwitchMyPositions } from "@/domains/common/components/switches/switch-my-positions"
import { CompactIcon } from "@/domains/icons"
import { LiquidityTypeTabs } from "@/domains/liquidity-page/components/liquidity-type-tabs"
import { useGovernanceToken } from "@/hooks/use-governance-token"
import { useNativeToken } from "@/hooks/use-native-token"

export const DesktopView = observer(() => {
  const scaleApp = useScaleApplication()
  const nativeToken = useNativeToken()
  const governanceToken = useGovernanceToken()

  return (
    <div className="flex w-full justify-between gap-4">
      <div className="flex max-w-[30%] flex-grow items-center justify-start gap-3 text-t200">
        <Search
          className="w-full max-w-[640px] text-t200"
          placeholder={`${governanceToken.name}, ${nativeToken.name}, BTC, ETH, 0x...`}
          value={scaleApp.Pages.Liquidity.search}
          onChange={(e) => scaleApp.Pages.Liquidity.setSearchFromUi(e.target.value)}
        />
      </div>
      <SwitchDetailedMode
        checked={scaleApp.Pages.Liquidity.isDetailed}
        onCheckedChange={(value) => scaleApp.Pages.Liquidity.setIsDetailedFromUi(value)}
      />
      <SwitchMyPositions
        checked={scaleApp.Pages.Liquidity.stakedOnly}
        onCheckedChange={(value) => scaleApp.Pages.Liquidity.setStakedOnlyFromUi(value)}
      />
      <div className="ml-auto flex w-fit items-center gap-3 text-t200">
        <LiquidityTypeTabs
          value={scaleApp.Pages.Liquidity.poolType === "cl" ? "all" : scaleApp.Pages.Liquidity.poolType}
          onValueChange={(value) => scaleApp.Pages.Liquidity.setPoolTypeFromUi(value)}
          className="bg-p400"
        />
      </div>
    </div>
  )
})
